<div class="product">
  <div class="product-container">
    @if (product().ribbon) {
      <div class="product-ribbon">{{ product().ribbon }}</div>
    }
    @if (noLink()) {
      <div class="image-container">
        <img
          [src]="currentImage"
          placeholder="assets/demo/images/product/t-shirt-placeholder.png"
          alt="product-img"
        />
      </div>
    } @else {
      <a
        [routerLink]="['/products', product().slug]"
        [state]="{ variantId: selectedVariant ? selectedVariant.id : null }"
        routerLinkActive="active"
        ariaCurrentWhenActive="page"
      >
        <div class="image-container">
          <img
            [src]="currentImage"
            placeholder="assets/demo/images/product/t-shirt-placeholder.png"
            alt="product-img"
          />
        </div>
      </a>
    }
  </div>
</div>
<div class="product-name-link">
  @if (noLink()) {
    <p>{{ product().name }}</p>
  } @else {
    <a
      [routerLink]="['/products', product().slug]"
      [state]="{ variantId: selectedVariant ? selectedVariant.id : null }"
      routerLinkActive="active"
      [title]="product().name"
      ariaCurrentWhenActive="page"
    >
      {{ product().name }}
    </a>
  }
</div>
@if (!disablePrices && !hidePrice()) {
  <div class="product-price-style">
    @if (product().original_display_price && product().original_display_price! > 0) {
      <span class="product-original-price">
        {{ product().original_display_price! | price | usdPipe }}
      </span>
    }
    @if (product().show_tier_prices_only && product().lowest_tier_prices_data?.price) {
      <span class="product-current-price">
        Starting at {{ product().lowest_tier_prices_data?.price || 0 | price | usdPipe }}
      </span>
    } @else if (product().lowest_tier_prices_data?.price) {
      <span class="product-current-price">
        {{ product().lowest_tier_prices_data?.price || 0 | price | usdPipe }}
      </span>
    } @else {
      <span class="product-current-price">
        {{ product().final_price | price | usdPipe }}
      </span>
    }
  </div>
}
<div class="flex justify-content-between align-items-center gap-2">
  <!-- Color Circles for product variants -->
  <div class="color-options">
    @for (variant of sortedVariants | slice: 0 : 5; track $index) {
      <div
        class="color-option"
        [ngClass]="{ selected: selectedVariant?.id === variant.id }"
        (click)="selectVariant(variant)"
        tabindex="0"
        (keyup.enter)="selectVariant(variant)"
        title="{{ variant.color }}"
      >
        <div
          class="color-circle"
          [ngStyle]="{
            'background-color': variant.primary_hex_color,
            border: isLightColor(variant.primary_hex_color) ? '1px solid #ccc' : 'none'
          }"
        >
          @if (variant.swatch_url) {
            <img [src]="variant.swatch_url" [alt]="variant.color" />
          }
        </div>
      </div>
    }

    <!-- If there are more than 5 variants, show a +N -->
    @if (product().product_variants!.length > 5) {
      <button
        type="button"
        class="extra-colors"
        (click)="navigateToProduct()"
        title="View all colors"
      >
        +{{ product().product_variants!.length - 5 }}
      </button>
    }
  </div>
  @if (cartIcon()) {
    <p-button
      styleClass="cart-button"
      [rounded]="true"
      [outlined]="true"
      (click)="handleCartClick()"
    >
      <img src="assets/img/icons/cart.svg" alt="cart" height="24" width="24" />
    </p-button>
  }
</div>
